export { OfferCard } from "./OfferCard";
export type { OfferCardProps } from "./OfferCard";
